import { useShowContext } from 'framework/show';
import { getTimezonesOptions } from 'framework/utils';
import EnumField from '../text/EnumField';
import { FieldProps } from '../types';

const TimezoneField = ({ value: inputValue, source = null }: FieldProps) => {
  const { data } = useShowContext();

  const value = inputValue || (data && data.getValueBySource(source));
  const timezonesOptions = getTimezonesOptions();
  const options = timezonesOptions.reduce((o, { value: key, label }) => ({ ...o, [key]: label }), {});

  return <EnumField label="Timezone" value={value} options={options} />;
};

export default TimezoneField;
